import { SmallSectionHeader } from 'components/Typography';
import styled from 'styled-components';
import { Divider } from '@material-ui/core';

export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    letter-spacing: 0;
    line-height: 23px;
  }
`;

export const ColoredDivider = styled(Divider)`
  && {
    background-color: #979797;
    opacity: 24%;
  }
`;
